import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { BlockTitle } from "../shared"
import { device } from "../../styles/media"

const InfoTitleContainer = styled.section`
  width: 100%;
  max-width: 780px;
  height: 343px;
  padding-top: ${props =>
    props.paddingTop ? `${props.paddingTop}px` : "124px"};
  padding-bottom: 84px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  @media ${device.mobileL} {
    height: auto;
  }
`

const TextBlockText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  width: 100%;
  max-width: 638px;
  margin: 0 auto;
  padding-bottom: 20px;
`

export const TextBlock = ({ title, text, paddingTop }) => {
  return (
    <InfoTitleContainer paddingTop={paddingTop}>
      <BlockTitle>{title}</BlockTitle>
      <TextBlockText>{text}</TextBlockText>
    </InfoTitleContainer>
  )
}

TextBlock.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  paddingTop: PropTypes.number,
}
